module.exports = __webpack_public_path__ + "static/media/tooltips_d_019.movie.109df105.mp4";